import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Toaster } from 'sonner';
import '@/App.css';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import ScientificProgramPage from '@/pages/ScientificProgramPage';
import FacultyPage from '@/pages/FacultyPage';
import AbstractSubmissionPage from '@/pages/AbstractSubmissionPage';
import RegistrationPage from '@/pages/RegistrationPage';
import TravelPage from '@/pages/TravelPage';
import ContactPage from '@/pages/ContactPage';
import AdminPage from '@/pages/AdminPage';
import ScannerPage from '@/pages/ScannerPage';
import AGOSPage from '@/pages/AGOSPage';
import MyRegistrationPage from '@/pages/MyRegistrationPage';
import AccommodationPage from '@/pages/AccommodationPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/program" element={<ScientificProgramPage />} />
          <Route path="/faculty" element={<FacultyPage />} />
          <Route path="/abstracts" element={<AbstractSubmissionPage />} />
          <Route path="/registration" element={<RegistrationPage />} />
          <Route path="/travel" element={<TravelPage />} />
          <Route path="/accommodation" element={<AccommodationPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/agos" element={<AGOSPage />} />
          <Route path="/my-registration" element={<MyRegistrationPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/scanner" element={<ScannerPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;